import { render, staticRenderFns } from "./IconCheckboxOn.vue?vue&type=template&id=19f98235&scoped=true&"
import script from "./IconCheckboxOn.vue?vue&type=script&lang=js&"
export * from "./IconCheckboxOn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f98235",
  null
  
)

export default component.exports